import { HStack, Select, Stack, Text } from "@chakra-ui/react";
import DatePicker from "react-datepicker";
import { LegacyRef, forwardRef } from "react";
import { KYDAdminFeedItem } from "@common/interfaces/KYDOrganization";
import LinkInput from "./LinkInput";
import ImageUploadInputWithPreview from "./ImageUploadInputWithPreview";

const ExampleCustomInput = forwardRef(
  (
    { value, onClick }: { value?: any; onClick?: any },
    ref: LegacyRef<HTMLParagraphElement>
  ) => (
    <HStack
      cursor={"pointer"}
      h={10}
      paddingInlineStart={4}
      rounded={"md"}
      borderColor={"gray.200"}
      borderWidth={"1px"}
      onClick={onClick}
      ref={ref}
    >
      {value ? (
        <Text>{value}</Text>
      ) : (
        <Text fontWeight={"medium"} color="gray.500">
          Click here to set a date
        </Text>
      )}
    </HStack>
  )
);

const ExternalEventForm = ({
  loading,
  updateDirtyText,
  dirtyText,
  feedItem,
}: {
  loading: { link: boolean; tickettype: boolean };
  updateDirtyText: (input: Record<string, any>) => void;
  dirtyText: Record<string, any>;
  feedItem: KYDAdminFeedItem | null;
}) => {
  return (
    <Stack>
      <LinkInput
        label="Event name"
        valueFrom="title"
        isDisabled={loading["link"]}
        updateDirtyText={updateDirtyText}
        dirtyText={dirtyText}
        feedItem={feedItem}
      />
      <LinkInput
        label="Venue name"
        valueFrom="venue_name"
        isDisabled={loading["link"]}
        updateDirtyText={updateDirtyText}
        dirtyText={dirtyText}
        feedItem={feedItem}
      />
      <LinkInput
        label="City"
        valueFrom="city"
        isDisabled={loading["link"]}
        updateDirtyText={updateDirtyText}
        dirtyText={dirtyText}
        feedItem={feedItem}
      />
      <Stack spacing={0}>
        <Text>Start Date</Text>
        <DatePicker
          placeholderText="Click to select a date"
          disabled={loading["tickettype"]}
          dateFormat="MMMM d, yyyy h:mm aa"
          showTimeSelect={true}
          closeOnScroll={true}
          minDate={new Date()}
          customInput={<ExampleCustomInput />}
          selected={
            dirtyText["item.start_at"]
              ? new Date(dirtyText["item.start_at"])
              : feedItem && feedItem.start_at
              ? new Date(feedItem.start_at!)
              : null
          }
          onChange={(e: Date) => {
            updateDirtyText({
              [`item.start_at`]: `${e.getFullYear()}-${
                e.getMonth() + 1
              }-${e.getDate()} ${e.getHours()}:${e.getMinutes()}`,
            });
          }}
        />
      </Stack>
      <Stack spacing={0}>
        <Text>Time Zone</Text>
        <Select
          isDisabled={loading["link"]}
          defaultValue={"America/New_York"}
          onChange={(e) => {
            updateDirtyText({ [`item.timezone`]: e.target.value });
          }}
          value={
            `item.timezone` in dirtyText
              ? dirtyText[`item.timezone`]
              : feedItem
              ? feedItem.timezone
              : ""
          }
        >
          <option value="America/New_York">Eastern</option>
          <option value="America/Chicago">Central</option>
          <option value="America/Denver">Mountain</option>
          <option value="America/Los_Angeles">Pacific</option>
        </Select>
      </Stack>
      <ImageUploadInputWithPreview
        dirtyText={dirtyText}
        onFileUploadSet={(file) => {
          updateDirtyText({ "item.fileToUpload": file });
        }}
        valueFrom="image"
        feedItem={feedItem}
        isDisabled={loading["link"]}
      />
    </Stack>
  );
};

export default ExternalEventForm;
